// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"25":"b06165b5","531":"b06165b5","777":"19eab3de"}[chunkId] + ".chunk.css";
};